import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js';
import csvHelper from '../importCSVHelper';


import {
	Validator
} from 'vee-validate'
export default {
	name: 'importProducts',
	components: {
		Loader
	},
	data: function () {
		return {
			file: '',
			error_message: '',
			success_message: '',
			error_seen: false,
			success_seen: false,
			csv_config: [],

			rejectedList: [],
			isLoading: false,
			listDataCsv: [],
			csvFields: [],

			user_type: '',
			useremail: '',
			client: '',
			clientid: '',
			listClientData: [],
			showSelectClient: false,
			ClientErr: '',
			simlifiedTemplate: 0,
			Simplified_model: false,
			isSimplifiedDiv: true
		}
	},
	created: function () { },
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		this.client=window.localStorage.getItem('selectedClient')
		this.clientid=this.client 

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.warehouseid = window.localStorage.getItem('selectedWarehouse');
				this.warehouse = this.warehouseid;
				// this.clientid = '';
				// this.getClientList();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				// this.clientid = '';
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid ? userdetail.clientid : this.client;
				this.warehouseid = window.localStorage.getItem('selectedWarehouse');
				this.warehouse = this.warehouseid;
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// clientSelected() {
		// 	this.clientid = this.client;
		// },
		submitFile() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (!this.clientid) {
				this.ClientErr = this.$t('srReport.clientError');
				return false;
			}
			if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
				let uploadFileExtension = this.$refs.file.files[0];
				if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
					//do nothing
					console.log(uploadFileExtension.name, "=====================Valid Extension====================");
				} else {
					this.$alertify.error(this.$t('productLogReport.selectCSVFile'));
					return false;
					console.log(uploadFileExtension.name, "=====================InValid Extension====================");
				}
			}
			this.isLoading = true;
			if (document.getElementById('downloadBtn'))
				document.getElementById('downloadBtn').disabled = false;
			var formData = new FormData();
			formData.append('csv', this.file);
			formData.append('clientid', window.localStorage.getItem('selectedClient'));
			formData.append('useremail', this.useremail);
			if(this.warehouseid){
				formData.append('warehouseid', this.warehouseid);
			}else {
				formData.append('warehouseid',null);

			}

			axios.post(apiUrl.api_url + 'loadPurchaseOrderCSV',
				formData, {
				headers: {
					'Authorization': 'Bearer ' + myStr,
					'Content-Type': 'multipart/form-data'
				}
			})
				.then((response) => {
					this.file = ''
					document.getElementById('file').value = '';
					response = response.data.data[0];

					if (response.status == true) {
						this.success_seen = true;
						this.error_message = '';
						this.error_seen = false;
						this.csv_config = response.data.csv_config;
						this.success_message = response.data.total_items_created.length + " PO's added successfully";

						if (response.data.total_items_rejected.length > 0) {
							this.error_message = response.data.total_items_rejected.length + " PO's rejected";
							this.error_seen = true;
							this.rejectedList = response.data.total_items_rejected;
						}
					} else {
						this.error_seen = true;
						this.success_seen = false;
						this.error_message = response.msg;
						this.success_message = '';
					}
					this.isLoading = false;
				})
				.catch(function () {
					this.error_seen = true;
					this.success_seen = false;
					this.error_message = this.$t('productLogReport.fileUploadErr');
					this.success_message = '';
					this.isLoading = false;
				});
		},
		downloadCSV() {
			document.getElementById('downloadBtn').disabled = true;
			this.isLoading = true;
			if (this.rejectedList.length > 0) {
				let csvFields = [];
				let csvArr = [];

				this.csv_config.forEach(function (field) {
					csvArr.push(field.db_col_name);
					csvFields.push({
						'fieldIndex': field.csv_col_name,
						'fieldColumn': field.db_col_name,
						'fieldName': this.$t(`importCsv.${field.db_col_name}`)
					});
				},this);
				// Add last column for reason
				csvArr.push("failure_reason");
				csvFields.push({
					'fieldIndex': csvFields.length - 1,
					'fieldColumn': "failure_reason",
					'fieldName': this.$t(`importCsv.${'failurereason'}`)
				})

				var dateFilder = [];
				var skipFilter = [];
				var csvResult = [];

				this.rejectedList.forEach(function (item) {
					var rowData = [];
					for (let i = 0; i < csvArr.length; i++) {
						if (item[csvArr[i]])
							rowData[csvArr[i]] = item[csvArr[i]]
						else
							rowData[csvArr[i]] = ''
					}
					csvResult.push(rowData);
				});

				csvHelper.data.jsonToCSV(this.$t('importCsv.poFailure'), csvResult, csvFields, dateFilder, skipFilter);
				this.isLoading = false;
			}
		},
		Simplifiedfunc(ev) {
			this.Simplified_model = document.getElementById("Simplified").checked
		},
		downloadTemplate() {
			if(window.localStorage.getItem('selectedClient')==='undefined'){
				this.$alertify.error(this.$t('common.clientError'))
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getCSVTemplate',
				'data': {
					'clientid': window.localStorage.getItem('selectedClient'),
					'type': 'purchase_order',
					'isSimplifiedTemplate': this.Simplified_model
				},
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(async (result) => {
					if (result.data.data[0].status) {
						let templateResult = [];
						result.data.data[0].data.forEach(function (field) {
							templateResult.push({
								'fieldIndex': field.csv_col_name,
								'fieldColumn': field.db_col_name,
								'fieldName': this.$t(`importCsv.${field.db_col_name}`)
							});
						},this);
						csvHelper.data.jsonToCSV(this.$t('importCsv.purchaseOrderTemplate'), [], templateResult, [], []);
					} else {
						this.$alertify.error(result.data.data[0].msg);
						return false;
					}
				})
		},
		resetFrom() {
			document.getElementById('file').value = '';
			this.error_seen = false;
			this.success_seen = false;
			this.rejectedList = [];
			this.file = ''

			// if (this.user_type != 'client_user') {
			// 	this.client = '';
			// 	this.clientid = '';
			// }
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/importCSV/importPO/importPO.component.js